import { render, staticRenderFns } from "./postAccountReceivableModalContent.vue?vue&type=template&id=221fd3e0&scoped=true"
import script from "./postAccountReceivableModalContent.vue?vue&type=script&lang=js"
export * from "./postAccountReceivableModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221fd3e0",
  null
  
)

export default component.exports